import React, { useEffect, useRef } from "react";
import "../Mlogo/MLogo.css";

export default function MDotCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight / 1.5;
    };
    resize();
    window.addEventListener("resize", resize);

    const rows = 30;
    const cols = 60;
    const amplitude = 45;
    const wavelength = 70;
    const speed = 0.03;
    const dotRadius = 2;

    const dots = [];

    for (let y = 0; y < rows; y++) {
      for (let x = 0; x < cols; x++) {
        const xOffset = (y % 2 === 0 ? 0 : canvas.width / cols / 2);
        dots.push({
          x: (x * canvas.width) / cols + xOffset,
          y: (y * canvas.height) / rows,
          baseY: (y * canvas.height) / rows,
        });
      }
    }

    let time = 0;

    function drawFrame() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);

      dots.forEach((dot) => {
        const wave =
          Math.sin(dot.x / wavelength + time + dot.baseY / 100) * amplitude;
        const y = dot.baseY + wave;

        const dx = (dot.x - canvas.width / 2) / (canvas.width / 2);
        const dy = (dot.baseY - canvas.height / 2) / (canvas.height / 2);
        const dist = Math.sqrt(dx * dx + dy * dy);

        const brightnessWave =
          Math.sin(dot.x / wavelength - time * 1.5 + dot.baseY / 120) * 0.25;

        let brightness = Math.max(0.2, 1 - dist * 1.2 + brightnessWave);
        brightness = Math.min(1, Math.max(0.1, brightness));

        const color = `rgba(138, 250, 200, ${brightness})`;

        ctx.fillStyle = color;
        ctx.beginPath();
        ctx.arc(dot.x, y, dotRadius, 0, Math.PI * 8);
        ctx.fill();
      });

      time += speed;
    }

    const frameInterval = 1000 / 20;
    const intervalId = setInterval(drawFrame, frameInterval);

    return () => {
      clearInterval(intervalId);
      window.removeEventListener("resize", resize);
    };
  }, []);

  return <canvas ref={canvasRef} id="mDotCanvas" className="dot-canvas"></canvas>;
}
